import root from 'window-or-global';

export const tabIndex = index => {
  root.document.body.tabIndex = index;
};
export const focus = () => root.document.body.focus({ preventScroll: true });
